import { connect } from "react-redux";
import { fetchSpecialCollectionDetails } from "./state/actions";
import SpecialCollectionDetailsComponent from "./SpecialCollectionDetails";

const mapStateToProps = (state) => ({
  isLoading: state.specialCollectionDetails.isLoading,
  error: state.specialCollectionDetails.error,
  data: state.specialCollectionDetails.data,
  hasError: state.specialCollectionDetails.hasError,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSpecialCollectionDetails: (specialCollectionPid) =>
    dispatch(fetchSpecialCollectionDetails(specialCollectionPid)),
});

export const SpecialCollectionDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialCollectionDetailsComponent);
